import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Countries"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Overview of added countries")
], -1)
const _hoisted_4 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "form-check form-check-sm me-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label text-nowrap",
  for: "show_active_check"
}, "Show only active", -1)
const _hoisted_7 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryModal = _resolveComponent("CountryModal")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_CountriesDataTable = _resolveComponent("CountriesDataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_CountryModal, {
        currentlySelectedCountry: _ctx.currentlySelectedCountry,
        title: _ctx.modalSetup.title,
        action: _ctx.modalSetup.action,
        onSaveChanges: _ctx.saveDataFromModal
      }, null, 8, ["currentlySelectedCountry", "title", "action", "onSaveChanges"]), [
        [_vShow, _ctx.isThereAModalActive]
      ]),
      _withDirectives(_createVNode(_component_DeleteModal, {
        onDelete: _ctx.deleteSelectedCountry,
        currentlySelectedEntry: this.currentlySelectedCountry.title
      }, null, 8, ["onDelete", "currentlySelectedEntry"]), [
        [_vShow, _ctx.isThereAModalActive]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_ctx.$can('can_manage_country_operational_status', 'all'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input form-check-sm cursor-pointer",
                  type: "checkbox",
                  id: "show_active_check",
                  checked: "",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShowActive && _ctx.handleShowActive(...args))),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showOnlyActive) = $event))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.showOnlyActive]
                ]),
                _hoisted_6
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : (_ctx.getData.length == 0)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: 'OOPS... Unfortunately no countries were found.'
              }, null, 8, ["description"]))
            : (_openBlock(), _createBlock(_component_CountriesDataTable, {
                key: 2,
                onChangeSort: _ctx.updateTableSort,
                onDeleteButtonClick: _ctx.openDeleteModal,
                onEditButtonClicked: _ctx.openEditModal,
                tableData: _ctx.getData
              }, null, 8, ["onChangeSort", "onDeleteButtonClick", "onEditButtonClicked", "tableData"]))
      ]),
      _createVNode(_component_Pagination, {
        currentPage: _ctx.pagination.currentPage,
        totalPages: _ctx.pagination.lastPage,
        onChangeCurrentPage: _ctx.changeCurrentPage
      }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
    ])
  ], 2))
}